import Layout from "../../../layout/Layout";
import React, { useEffect, useRef, useState } from "react";
import { Container } from "@mui/system";
import {
  Button,
  Checkbox,
  CircularProgress,
  Pagination,
  PaginationItem,
  Stack,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  ListItemButton,
  ListItemIcon,
  Select,
  TextField,
  Tooltip,
  Typography,
  MenuItem,
  Autocomplete,
  Backdrop,
} from "@mui/material";
import {
  Edit as EditIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  Delete,
} from "@mui/icons-material";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { config, todoAPI, userData } from "../../../config";
import axios from "axios";



export default function Todo() {
  const [txtTodo, setTodo] = useState("");
  const [todoList, setTodoList] = useState([]);
  const [ticketList, setTicketList] = useState([]);
  const [isSubmitDisable, setIsSubmitDisable] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [checked, setChecked] = useState([0]);
  const [totalCount, setTotalCount] = useState(0);
  const [ticketID, setTicketID] = useState(0);
  const [todoID, setTodoID] = useState(0);
  const limit = 5;

  const validationSchema = Yup.object().shape({
    txtTodo: Yup.string()
      .required("To do description is required")
      .min(2, "Name must be at least 2 characters")
      .max(60, "Name cannot be more than 60 characters"),
  });

  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  };
  const { register, handleSubmit, formState, reset, setValue, getValues } =
    useForm(formOptions);
  const { errors } = formState;

  // EDIT FUNCTION START

  const editTodo = (rowId) => {
    setTodoID(rowId);
    const found = todoList.find((obj) => {
      return obj.id === rowId;
    });
    setValue("txtTodo", found.description);
    setTodo(found.description);

    setValue("intTicketID", found.ticket_id);
    setTicketID(found.ticket_id);
  };

  // EDIT FUNCTION END

  // FETCH DATA START

  const flagUseEffect = useRef(false);
  useEffect(() => {
    if (flagUseEffect.current === false) {
      setIsDataLoading(true);
      let data = JSON.stringify({
        intTicketID: 0,
        txtRemainder: "",
        txtDescription: "",
        intStatus: 1,
        txtUserID: 0,
        intId: 0,
        intLimit: limit,
        intOffset: 0,
        intSPType: 1,
      });
      getTodo(data);


      data = JSON.stringify({
        intTicketID: 0,
        txtRemainder: "",
        txtDescription: "",
        intStatus: 1,
        txtUserID: 0,
        intId: 0,
        intLimit: limit,
        intOffset: 0,
        intSPType: 3,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = todoAPI;
      axios(config)
      .then(function (response) {
        setTicketList(response.data.data)
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });

      return () => {
        flagUseEffect.current = true;
      };
    }
  }, []);

  const getTodo = (requestData) => {
    config.method = "PATCH";
    config.data = requestData;
    config.url = todoAPI;

    axios(config)
      .then(function (response) {
        setTodoList(response.data.data);
        setIsDataLoading(false);
        setTotalCount(Math.round(response.data.count / limit));
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  // FETCH DATA END

  // TODO COMPLETE START

  const handleTodoComplete = (id) => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];
    let flagComplete = 0;
    if (currentIndex === -1) {
      newChecked.push(id);
      flagComplete = 1;
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const found = todoList.find((obj) => {
      return obj.id === id;
    });

    const data = JSON.stringify({
      intTicketID: found.ticket_id,
      txtRemainder: "",
      txtDescription: found.description,
      intStatus: 1,
      intUserID: userData.id,
      intId: id,
      intLimit: limit,
      intOffset: 0,
      intSPType: 2,
      intCompletedFlag: flagComplete,
    });

    config.method = "POST";
    config.data = data;
    config.url = todoAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        setTodoList(response.data.data);
        setIsDataLoading(false);
        setTotalCount(Math.round(response.data.count / limit));
        setTodoID(0);
        setTodo("");
        setValue("txtTodo", "");
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });

    setChecked(newChecked);
  };

  // TODO COMPLETE END

  // INSERT TODO START

  const onSubmit = (requestData) => {
    const data = JSON.stringify({
      intTicketID: ticketID,
      txtRemainder: "",
      txtDescription: requestData.txtTodo,
      intStatus: 1,
      intUserID: userData.id,
      intId: todoID,
      intLimit: limit,
      intOffset: 0,
      intSPType: 2,
    });

    config.method = "POST";
    config.data = data;
    config.url = todoAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        setTodoList(response.data.data);
        setIsDataLoading(false);
        setTotalCount(Math.round(response.data.count / limit));
        setTodoID(0);
        setTodo("");
        setValue("txtTodo", "");
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  // INSERT TODO END

  
  // INSERT TODO START

  const handleDelete = (todoID) => {
    const found = todoList.find((obj) => obj.id === todoID);

    const data = JSON.stringify({
      intTicketID: found ? found.ticket_id : 0,
      txtRemainder: "",
      txtDescription: "",
      intStatus: 0,
      intUserID: userData.id,
      intId: todoID,
      intLimit: limit,
      intOffset: 0,
      intSPType: 4,
    });

    config.method = "DELETE";
    config.data = data;
    config.url = todoAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        setTodoList(response.data.data);
        setIsDataLoading(false);
        setTotalCount(Math.round(response.data.count / limit));
        setTodoID(0);
        setTodo("");
        setValue("txtTodo", "");
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  // INSERT TODO END

  // PAGINATION START

  const handleTodoPagination = (e) => {
    setIsDataLoading(true);
    const intOffset =
      e.target.innerText === "1" ? 0 : (parseInt(e.target.innerText) - 1) * 2;
    const data = JSON.stringify({
      intTicketID: 0,
      txtRemainder: "",
      txtDescription: "",
      intStatus: 1,
      txtUserID: 0,
      intId: 0,
      intLimit: limit,
      intOffset: intOffset,
      intSPType: 1,
    });
    getTodo(data);
  };

  // PAGINATION END

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitDisable}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Grid container spacing={5}>
        <Grid item lg={4} md={4} xs={12}>
          <div className={`white-bg`}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Autocomplete
                id="ticket-id-autocomplete"
                options={ticketList}
                getOptionLabel={(option) => (option.ticketID ? option.ticketID.toString() : "")}
                value={ticketList.find(t => t.ticketID === ticketID) || null}
                onChange={(event, newValue) => {
                  const val = newValue ? newValue.ticketID : 0;
                  setTicketID(val);
                  setValue("intTicketID", val);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Ticket ID" variant="outlined" />
                )}
                className="form-control"
                fullWidth
              />

              <FormControl className={`form-control`} fullWidth>
                <TextField
                  name="txtTodo"
                  type="text"
                  label="To do"
                  value={txtTodo}
                  onChange={(e) => {
                    setTodo(e.target.value);
                    setValue("txtTodo", e.target.value);
                  }}
                  className={`${errors.txtTodo ? "is-invalid" : ""}`}
                />
                <Typography className="invalid-feedback">
                  {errors.txtTodo?.message}
                </Typography>
              </FormControl>

              <FormControl className={`btn-section`}>
                <Button
                  size="large"
                  variant="outlined"
                  color="primary"
                  type="submit"
                  disabled={isSubmitDisable}
                >
                  Submit
                </Button>
              </FormControl>
            </form>
          </div>
        </Grid>
        <Grid item lg={8} md={8} xs={12}>
          {todoList.length === 0 ? (
            <></>
          ) : (
            <Stack spacing={2}>
              <Pagination
                onChange={handleTodoPagination}
                hidePrevButton
                hideNextButton
                count={totalCount}
                renderItem={(item) => (
                  <PaginationItem
                    onChange={(e) => console.log(e.target.innerText)}
                    components={{
                      previous: ArrowBackIcon,
                      next: ArrowForwardIcon,
                    }}
                    {...item}
                  />
                )}
              />
            </Stack>
          )}
          {isDataLoading ? (
            <div className={`spinner-white-bg`}>
              <div className="spinner"></div>
            </div>
          ) : (
            <div>
              {todoList.length === 0 ? (
                <Typography variant="h5">No data found</Typography>
              ) : (
                todoList.map((row, index) => {
                  const currentIndex = checked.indexOf(row.id);
                  const newChecked = [...checked];
                  if (currentIndex === -1 && row.completed_flag === 1) {
                    newChecked.push(row.id);
                    setChecked(newChecked);
                    console.log(row.id)
                  }

                  return (
                    <Grid container key={index} className={`card-design`}>
                      <Grid
                        item
                        xs={8}
                        lg={8}
                        display="grid"
                        gridTemplateColumns={`50px auto`}
                      >
                        <ListItemButton
                          role={undefined}
                          onClick={() => {
                            handleTodoComplete(row.id);
                          }}
                          dense
                        >
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              checked={
                                checked.indexOf(row.id) !== -1
                              }
                              tabIndex={-1}
                              disableRipple
                              inputProps={{ "aria-labelledby": "" }}
                            />
                          </ListItemIcon>
                        </ListItemButton>
                        <div>
                          <Typography
                            className={`type-title ${
                              checked.indexOf(row.id) !== -1
                                ? "text-strike"
                                : ""
                            }`}
                          >
                            {row.description}
                          </Typography>
                          <Typography className="type-subtitle">
                            Ticket ID # {row.ticket_id}
                          </Typography>
                        </div>
                      </Grid>

                      <Grid item xs={8} lg={2}>
                        {/* <Typography>Set remainder</Typography> */}
                      </Grid>
                      <Grid item xs={4} lg={2} textAlign={"center"}>
                        <Tooltip title="Edit">
                          <IconButton onClick={() => editTodo(row.id)}>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton onClick={() => handleDelete(row.id)} >
                            <Delete sx={{ color: `red` }} />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  );
                })
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </Layout>
  );
}
